import tableSlice from "@/widgets/elements/table/reducer/table.slice";
import formDrawerReducer from "@/widgets/elements/formDrawer/formdrawer.slice";
import LoginSlice from "./reducers/LoginSlice";
import sidebarReducer from "./reducers/SidebarSlice";
import { configureStore, type Action, type ThunkAction } from "@reduxjs/toolkit";

export const store = configureStore({
  reducer: {
    sideBarData: sidebarReducer,
    formDrawerState: formDrawerReducer,
    tableState: tableSlice,
    LoginState: LoginSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

